<div class="flex flex-col max-h-[85vh]">
  <gnx-dialog-header title="ROLES & PERMISSIONS" [subTitle]="dialogTitle" (close)="close()" />

  @if (isCreateMode) {
    <div class="p-[16px_24px] border-0 border-b border-solid border-[#eee]">
      <div class="flex items-center gap-[8px] mb-[6px]">
        <label gnxLabel class="text-start !mb-0">Role Name*</label>
        @if (roleNameField().pending()) {
          <mat-spinner [diameter]="14" matTooltip="Checking name availability" matTooltipClass="blue-md-tooltip" />
        }
      </div>
      <input gnxInput type="text" placeholder="Enter role name" [formField]="roleNameField" />
      @if (nameExists()) {
        <div class="text-[12px] text-[#f44336] mt-[4px] text-start">Role name already exists</div>
      }
    </div>
  }

  @if (!isViewMode && !isCreateMode) {
    @if (this.data.isDefaultRole) {
      <div class="flex items-center gap-[8px] p-[10px_24px] bg-[#e8f4f8] text-[13px] text-[#262626] text-start">
        <img src="/assets/svg/info.svg" width="14" height="14" />
        <span>These permissions apply to all users without a role.</span>
      </div>
    } @else {
      <div class="flex items-center gap-[8px] p-[10px_24px] bg-[#e8f4f8] text-[13px] text-[#262626] text-start">
        <img src="/assets/svg/info.svg" width="14" height="14" />
        <span
          >Changes in permissions will take effect after saving.<br />Members currently logged in need to refresh (or
          re-login) for changes to take effect.</span
        >
      </div>
    }
  }

  @if (isViewMode) {
    <div class="flex items-center gap-[8px] p-[10px_24px] bg-[#e9eded] text-[13px] text-[#262626]">
      <img src="/assets/svg/info.svg" width="14" height="14" />
      <span>You are viewing this role's permissions. Contact your admin to request changes.</span>
    </div>
  }

  <div class="flex-[1] overflow-y-auto p-[16px_24px_16px]">
    @let loading = auth0Store.availablePermissionsLoading() ?? true;
    @let sections = auth0Store.availablePermissionsGrouped();
    @if (loading) {
      <div class="pt-[24px] text-center">
        <gnx-dots-loader />
      </div>
    } @else if (sections?.length) {
      @for (section of sections; track section.section) {
        <gnx-card class="mt-[16px]" [title]="section.section" [loaded]="true">
          @for (perm of section.permissions; track perm.name) {
            <div class="permission-row">
              <div class="flex items-center">
                <span class="text-[14px] text-[#373737]">{{ perm.display_name }}</span>
                @if (perm.tooltip) {
                  <img
                    src="/assets/svg/info.svg"
                    width="13"
                    height="13"
                    [matTooltip]="perm.tooltip"
                    matTooltipClass="blue-md-tooltip wider"
                    class="ml-[4px] opacity-50"
                  />
                }
              </div>
              <mat-radio-group
                [value]="permissionStates[perm.name]"
                (change)="togglePermission(perm.name, $event.value)"
                [disabled]="isViewMode"
              >
                @for (option of permissionOptions; track option.value) {
                  <mat-radio-button [value]="option.value">{{ option.label }}</mat-radio-button>
                }
              </mat-radio-group>
            </div>
          }
        </gnx-card>
      }
    } @else {
      <div class="flex flex-col items-center pt-[40px] text-center">
        <span class="text-[15px] text-[#7a7b85]">Failed to load permissions. Please close and try again.</span>
      </div>
    }
  </div>

  @let saving = auth0Store.saveRoleInProgress() ?? false;
  <gnx-dialog-footer
    [cancelLabel]="isViewMode ? 'Close' : 'Cancel'"
    saveLabel="Save Role"
    [saveDisabled]="!canSave || saving"
    [saveLoading]="saving"
    [saveTooltip]="isViewMode ? 'Only admins can modify roles' : ''"
    (cancel)="close()"
    (save)="save()"
  />
</div>
